/* Parcours fidélité — RJ-01 (Bible §23–24 · batch 10 · D-53).
   A step is ONE demande and ONE roue. Step names are templates, never
   mandatory copy. Only a committed eligible participation advances a step — a
   scan, a tap, a sign-in or Test Mode never does. An unset « après la dernière
   étape » rule blocks publish, and says so here.
   The four rules are printed on the screen: a merchant should not have to
   discover them from behaviour. */
import { useNavigate } from 'react-router-dom'
import { Button, EmptyState, ErrorState, Hint, List, ListRow, Note, PageHeader, Pill } from '@/ui'
import { REGLES_PARCOURS, RIEN_NE_CONDITIONNE, VOCAB } from '@/lib/vocab'
import { useJourney } from './api'
import { Chargement, DEMANDE_MOT, MARQUE } from './parts'

export default function Parcours() {
  const { data, isPending, isError, refetch } = useJourney()
  const nav = useNavigate()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger le parcours."
      lost="Votre connexion a peut-être sauté — rien n’a été perdu."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  const d = data
  return (
    <div className="page">
      <PageHeader
        title={d.name}
        description={<>Une demande par visite, une roue par étape&nbsp;: ce que vous demandez au
          client cette fois-ci, et ce qu’il joue en échange de sa visite.
          <Hint label="Campagne">{VOCAB.campagne.sentence}</Hint></>}
        next={<>les demandes se composent dans <a href="#" onClick={e => { e.preventDefault(); nav('/reponses') }}>Demandes</a>, les roues dans <a href="#" onClick={e => { e.preventDefault(); nav('/cadeaux?onglet=roues') }}>Cadeaux › Vos roues</a>.</>}
        aside={<Pill tone={d.status === 'Actif' ? 'ok' : 'warn'}>{d.status} · {d.version}</Pill>} />

      {d.stages.length === 0 ? (
        <EmptyState title="Aucune étape pour l’instant."
          why="Un parcours se construit étape par étape ; la première suffit pour démarrer." />
      ) : (
        <List>
          {d.stages.map(s => (
            <ListRow key={s.id}
              icon={<span aria-hidden style={{ fontSize: 18 }}>{MARQUE[s.demandeKind]}</span>}
              title={s.label}
              meta={<><b>{DEMANDE_MOT[s.demandeKind]}</b> — {s.demande} · roue&nbsp;: {s.roue}
                {s.roueOwn ? <> <Pill tone="ink">propre à l’étape</Pill></> : <span className="f-help"> (celle de la campagne)</span>}</>}
              end={<Button size="sm" variant="quiet" onClick={() => nav('/campagnes/parcours/etape')}>Modifier</Button>} />
          ))}
          <ListRow
            icon={<span aria-hidden style={{ fontSize: 18 }}>↻</span>}
            title="Après la dernière étape"
            meta={d.plusRule ?? 'Règle non définie — la publication est bloquée tant qu’elle manque'}
            end={d.plusRule
              ? <Pill tone="ok">Défini</Pill>
              : <Button size="sm" variant="primary" onClick={() => nav('/campagnes/parcours/apres-etape-5')}>Définir</Button>} />
        </List>
      )}

      {!d.plusRule && (
        <Note tone="candour">
          La règle « après la dernière étape » doit être choisie avant publication&nbsp;: sans elle,
          un client qui termine le parcours n’a plus de suite définie.
        </Note>
      )}

      <h3 className="t-eyebrow" style={{ margin: '20px 0 8px' }}>Les règles du parcours</h3>
      <List>
        {REGLES_PARCOURS.map((r, i) => (
          <ListRow key={r.rule}
            icon={<span className="esect-n" aria-hidden>{i + 1}</span>}
            title={r.rule} meta={<>Pourquoi&nbsp;: {r.why}</>} />
        ))}
      </List>
      {/* Rule 3 names the rhythm; RJ-07 is where it is actually chosen, and it had
          no in-app route to it. « modifier » on Établissement's « Fenêtre de
          participation » should land there too — that one is the Orchestrator's. */}
      <p className="f-help" style={{ margin: '10px 0 0' }}>
        Le rythme se règle par secteur, avec ce qu’il coûte par participation&nbsp;:
        {' '}<a href="#" onClick={e => { e.preventDefault(); nav('/campagnes/parcours/rythme') }}>Rythme &amp; éligibilité</a>.
        L’exposition des plateformes (la règle 2) a son propre écran&nbsp;:
        {' '}<a href="#" onClick={e => { e.preventDefault(); nav('/campagnes/parcours/exposition') }}>Exposition des liens d’avis</a>.
      </p>

      <Note tone="ok" >{RIEN_NE_CONDITIONNE}</Note>
    </div>
  )
}
